<template>
	<div class="link-ques">
		<div class="all-box">
			<tpl-detail v-for="item in surveyList" :key="item.id" :titName="customSurvey(item) +'  (该问卷仅限填写一次，且不能修改，请您谨慎填写！)'">
				<template slot="body">
					<ul>
						<li v-for="i,index in item.questionDTOS" :key="i.id">
							<h2>
								<span>{{index+1}}</span>
								{{i.question}} （{{i.quesType=="lonely"?"单选题":"多选题"}}）
							</h2>
							<div class="radio" v-if="i.quesType=='lonely'">
								<el-radio-group v-model="i.answer">
									<el-radio :label="hi.order" v-for="hi in i.quesOption" :key="hi.id">{{hi.order}} {{hi.desc}}</el-radio>
								</el-radio-group>
							</div>
							<div class="radio" v-if="i.quesType=='more'">
								<el-checkbox-group v-model="i.answer">
									<el-checkbox :label="hi.order" v-for="hi in i.quesOption" :key="hi.id">{{hi.order}} {{hi.desc}}</el-checkbox>
								</el-checkbox-group>
							</div>
						</li>

						<li class="clearfix">
							<el-button v-if="!item.questionDTOS[0].disabled" size="small" type="primary" class="fr sub-btn" @click="subQues(item)">提交</el-button>
						</li>
					</ul>
				</template>
			</tpl-detail>
		</div>
	</div>
</template>
<script>
import { getCurrentDate } from "@/utils/index.js";
import TplDetail from "@/templates/TplDetail.vue";
import { postData, getData, postJson } from "@/http/fetch.js";
import { mapState } from "vuex";
export default {
	components: {
		TplDetail
	},
	props: {
		linkInfo: ""
	},
	computed: {
		...mapState(["userInfo"])
	},
	data() {
		return {
			surveyList: "",
			surveyTypeOptions: [
				{ value: "dy", label: "调研" },
				{ value: "tp", label: "投票" },
				{ value: "zdy", label: "自定义" }
			]
		};
	},
	created() {
		this.init();
	},
	methods: {
		init() {
			this.getQuesList();
		},
		async getQuesList() {
			try {
				let surveyList = await postJson(
					"/node/getNodeTopicSurveyQuestionList",
					{
						actCode: sessionStorage.getItem("actCode"),
						nodeCode: this.linkInfo.nodeCode,
						operatorId: this.userInfo.userId
					}
				);
				surveyList.forEach(item => {
					//无用
					item.questionList.forEach(i => {
						i.quesOption = JSON.parse(i.quesOption);
					});
					//主要
					item.questionDTOS = item.questionList;
					item.questionDTOS.forEach(i => {
						if (!i.surveyAnswer) {
							//没有答案
							i.answer = [];
							i.disabled = false;
						} else {
							i.answer = JSON.parse(i.surveyAnswer);
							i.disabled = true;
						}
					});
				});
				this.surveyList = surveyList;
			} catch (err) {
				console.log("getQuesListerr", err);
			}
		},
		customSurvey(i) {
			if (i.surveyType == "zdy") {
				return i.customSurvey;
			} else {
				return this.surveyTypeOptions.find(item => item.value == i.surveyType)
					.label;
			}
		},
		async subQues(i) {
			if (i.questionDTOS.some(item => item.answer.length == 0)) {
				this.$message.error("请完善答案信息!");
				return;
			}
			let surveyAnswerList = [];
			i.questionDTOS.forEach(item => {
				surveyAnswerList.push({
					answer: JSON.stringify(item.answer),
					quesCode: item.quesCode
				});
			});
			await postJson("/node/saveNodeTopicSurveyAnswer", {
				actCode: i.actCode,
				nodeCode: i.nodeCode,
				operatorId: this.userInfo.userId,
				surveyAnswerList: surveyAnswerList,
				surveyCode: i.surveyCode
			});
			this.$message.success("问卷提交成功");
			this.getQuesList();
		}
	},
	watch: {}
};
</script>
<style lang="less" scoped>
.link-ques {
	ul {
		padding-left: 5px;
		li {
			padding: 6.5px 0px;
			h2 {
				font-size: 13px;
				span {
					font-size: 14px;
					margin-right: 7px;
				}
			}
			.radio {
				// border: 1px solid #000;
				padding-left: 30px;
				margin-top: 7px;
				margin-bottom: 5px;
			}
		}
	}
}
</style>